import React from "react";
import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Zoom,
  Tabs,
  Tab,
  Link,
  Button,
  SvgIcon,
} from "@mui/material";
import { t, Trans } from "@lingui/macro";
import BankBannerBg from "../../assets/images/bank-banner.png";
import BankBannerMobileBg from "../../assets/images/bank-banner-m.png";
import BankBottomBg from "../../assets/images/bank-bottom-bg.png";
import BankBottomCard from "../../assets/images/bank-bottom-card.png";
import FooterBg from "../../assets/images/footer-bg.png";
import BankBottomMobile from "../../assets/images/bank-bottom-img.png";
import BankBottom from "../../assets/images/bank-bottom.png";
import { ReactComponent as BankIcon1 } from "../../assets/icons/bank-icon-1.svg";
import { ReactComponent as BankIcon2 } from "../../assets/icons/bank-icon-2.svg";
import { useAppSelector, useMobile } from "../../hooks";

const yellowTextStyle = {
  background: "none",
  WebkitTextFillColor: "#FFD700",
  color: "#FFD700",
} as const;

const gradientTextStyle = {
  background: "linear-gradient(180deg, #FFF 0%, #999 93.75%)",
  backgroundClip: "text",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  fontSize: { sm: "60px", xs: "30px" },
  fontWeight: "700",
  lineHeight: { sm: "72px", xs: "38px" },
  letterSpacing: "0.6px",
} as const;

const BankCard = () => {
  const { isSmallScreen } = useMobile();

  return (
    <Box
      display="flex"
      alignItems={"center"}
      flexDirection={"column"}
      sx={{
        mb: "100px",
        position: "relative",
      }}
    >
      {/* content */}
      <Box
        sx={{
          maxWidth: "1340px",
          width: { xs: "100%", sm: "97%" },
          pt: { sm: "87px", xs: "18px" },
          px: { xs: "15px", sm: "0" },
          position: "relative",
          zIndex: "1",
        }}
      >
        <Box
          sx={{
            maxWidth: "1000px",
            margin: "0 auto",
            mb: {
              sm: "40px",
              xs: "24px",
            },
          }}
        >
          <Box
            sx={{
              mb: { sm: "40px", xs: "24px" },
            }}
          >
            <Typography sx={gradientTextStyle} align="center">
              <Trans id="bank.card.title">
                The First <span style={yellowTextStyle}>NovaBank</span> Spending Card, Exclusively for You!
              </Trans>
            </Typography>
            <Typography
              align="center"
              sx={{
                fontSize: "18px",
                fontWeight: "400",
                lineHeight: "28px",
                letterSpacing: "0.36px",
                color: "#C0C0C0",
              }}
            >
              <Trans>Higher perk adoption, instant expense management, simple benefits access and much more</Trans>
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" justifyContent="center">
            <Link
              component={"div"}
              sx={{
                width: { sm: "344px", xs: "196px" },
                borderRadius: "6px",
                height: { sm: "55px", xs: "48px" },
                display: "block",
                border: "1px solid #000",
                background: "#FCD000",
                boxShadow: "-3px 3px 0px 0px #ECAA00",
                "&:hover": {
                  transform: "scale(1.02)",
                },
              }}
            >
              <Button
                sx={{
                  width: "100%",
                  height: "100%",
                  background: "transparent",
                  "&:hover": {
                    background: "transparent",
                  },
                }}
                variant="contained"
              >
                <Typography
                  sx={{
                    color: "#000",
                    fontSize: "16px",
                    fontWeight: "500",
                  }}
                >
                  <Trans>Coming Soon</Trans>
                </Typography>
              </Button>
            </Link>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          width: "100%",
          mt: { sm: "-200px", xs: "0" },
          mb: "100px",
          "&>img": {
            width: "100%",
            height: "100%",
          },
        }}
      >
        <img src={isSmallScreen ? BankBannerMobileBg : BankBannerBg} />
      </Box>
      <Box
        sx={{
          // background: { sm: `url(${BankBottomBg}) no-repeat center center`, xs: "none" },
          // backgroundSize: "cover",
          width: "100%",
          height: "100%",
          position: "relative",
          minHeight: { sm: "1342px", xs: "370px" },
        }}
      >
        <Box
          sx={{
            maxWidth: "792px",
            width: "100%",
            margin: "0 auto",
            position: "relative",
            zIndex: "2",
          }}
        >
          <Typography sx={gradientTextStyle} align="center">
            <Trans>Establish global Novabank payment and experience payment in seconds</Trans>
          </Typography>
        </Box>
        <Box
          sx={{
            width: "100%",
            position: "relative",
            mt: { sm: "-200px", xs: "-20px" },
            // 使用aspect-ratio属性（更现代的方式）
            aspectRatio: {
              sm: "1920/1422", // 桌面端图片比例
              xs: "375/366", // 移动端图片比例
            },
            "&>img": {
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center",
            },
          }}
        >
          <img
            src={isSmallScreen ? BankBottomMobile : BankBottom}
            alt=""
            loading="lazy" // 添加懒加载
          />
        </Box>
        {/* <Box
          sx={{
            position: "absolute",
            left: "49%",
            top: "460px",
            width: "20.5%",
            height: "34.1%",
            transform: "translateX(-50%)",
            display: { sm: "block", xs: "none" },
            "&>img": {
              width: "100%",
              height: "100%",
            },
          }}
        >
          <img src={BankBottomCard} />
          <Box
            sx={{
              width: "65%",
              height: "37%",
              borderRadius: "26.825px",
              // border: "1.073px solid #FFF",
              background: "radial-gradient(161.21% 160.39% at 5.71% -44.13%, #000 0%, rgba(0, 0, 0, 0.27) 100%)",
              backdropFilter: "blur(27.897808074951172px)",
              position: "absolute",
              left: "-53%",
              top: "-10%",
              p: "30px",
              // transform: "translate(-50%, -50%)",
            }}
          >
            <SvgIcon component={BankIcon1} viewBox="0 0 41 33" />
            <Typography
              sx={{
                color: "#fff",
                fontSize: "20px",
                fontWeight: "400",
              }}
            >
              <Trans>No Annual Fees.</Trans>
            </Typography>
          </Box>
          <Box
            sx={{
              width: "65%",
              height: "37%",
              borderRadius: "26.825px",
              // border: "1.073px solid #FFF",
              background: "radial-gradient(161.21% 160.39% at 5.71% -44.13%, #000 0%, rgba(0, 0, 0, 0.27) 100%)",
              backdropFilter: "blur(27.897808074951172px)",
              position: "absolute",
              right: "-80%",
              top: "32%",
              p: "30px",
              // transform: "translate(-50%, -50%)",
            }}
          >
            <SvgIcon component={BankIcon1} viewBox="0 0 41 33" />
            <Typography
              sx={{
                color: "#fff",
                fontSize: "20px",
                fontWeight: "400",
              }}
            >
              <Trans>No Rewards Redemption Fees.</Trans>
            </Typography>
          </Box>
          <Box
            sx={{
              width: "65%",
              height: "37%",
              borderRadius: "26.825px",
              background: "radial-gradient(161.21% 160.39% at 5.71% -44.13%, #000 0%, rgba(0, 0, 0, 0.27) 100%)",
              backdropFilter: "blur(27.897808074951172px)",
              position: "absolute",
              left: "-88%",
              top: "44%",
              p: "30px",
              // transform: "translate(-50%, -50%)",
            }}
          >
            <SvgIcon component={BankIcon2} viewBox="0 0 34 33" />
            <Typography
              sx={{
                color: "#fff",
                fontSize: "20px",
                fontWeight: "400",
              }}
            >
              <Trans>No Joining Fees.</Trans>
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            width: "100%",
            height: "500px",
            background: "linear-gradient(180deg, rgba(38, 38, 38, 0.00) 0%, #000 88.75%)",
            position: "absolute",
            left: 0,
            bottom: "0",
          }}
        /> */}
      </Box>
      {/* left top bg */}
      <Box
        sx={{
          position: "absolute",
          left: "-20px",
          top: { xs: "-50px", sm: "-25px" },
          width: { xs: "186px", sm: "390px" },
          height: { xs: "309px", sm: "509px" },
          "&> img": {
            width: "100%",
            height: "100%",
          },
        }}
      >
        <img src={FooterBg} />
      </Box>
    </Box>
  );
};

export default BankCard;
